import { Cancel01Icon, Download04Icon, PlusSignIcon } from "hugeicons-react";
import { useState } from "react";
import { MemoryImportModal } from "./MemoryImportModal";

interface MemorySectionProps {
  localMemoryArray: string[];
  expandedMemoryIndex: number | null;
  setExpandedMemoryIndex: React.Dispatch<React.SetStateAction<number | null>>;
  handleMemoryChange: (index: number, value: string) => void;
  handleMemorySubmit: () => void;
  handleAddMemory: () => void;
  handleRemoveMemory: (index: number) => void;
  hasChanges: boolean;
}

export const MemorySection = ({
  localMemoryArray,
  expandedMemoryIndex,
  setExpandedMemoryIndex,
  handleMemoryChange,
  handleMemorySubmit,
  handleAddMemory,
  handleRemoveMemory,
  hasChanges
}: MemorySectionProps) => {
  const [removingIndex, setRemovingIndex] = useState<number | null>(null);
  const [isImportOpen, setIsImportOpen] = useState(false);

  const handleRemoveWithAnimation = (index: number) => {
    setRemovingIndex(index);
    setTimeout(() => {
      handleRemoveMemory(index);
      setRemovingIndex(null);
    }, 400);
  };

  return (
    <div className="settings-item">
      <div className="settings-item-header memory-section-header">
        <div>
          <h3>Personalization</h3>
          <p className="memory-description">
            Add personal details, preferences to customize your StudyBuddy's responses.
          </p>
        </div>
        <button type="button" className="memory-import-open" onClick={() => setIsImportOpen(true)}>
          <Download04Icon size={14} />
          Import Memory
        </button>
      </div>
      <div className="memory-list">
        {Array.isArray(localMemoryArray) && localMemoryArray.length === 0 && (
          <div className="empty-memory-message">
            No personalization added yet. Click the '+' button to get started!
          </div>
        )}
        {Array.isArray(localMemoryArray) && localMemoryArray.map((memory, index) => (
          <div key={index} className={`memory-item ${removingIndex === index ? 'removing' : ''}`}>
            {expandedMemoryIndex === index || memory === '' ? (
              <textarea
                value={memory}
                onChange={(e) => {
                  handleMemoryChange(index, e.target.value);
                  setExpandedMemoryIndex(index);
                }}
                onBlur={() => setExpandedMemoryIndex(null)}
                autoFocus
                placeholder="E.g., 'I'm a high school student focusing on AP Biology and Chemistry.'"
              />
            ) : (
              <div 
                className="memory-preview" 
                onClick={() => setExpandedMemoryIndex(index)}
              >
                {memory || 'Click to add details...'}
              </div>
            )}
            <button 
              type="button" 
              className="memory-cancel-button" 
              onClick={() => handleRemoveWithAnimation(index)}
            >
              <Cancel01Icon />
            </button>
          </div>
        ))}
      </div>

      <div className="memory-actions">
        <button 
          type="button" 
          className="save-button" 
          onClick={handleMemorySubmit}
          disabled={!hasChanges} 
          style={{ 
            opacity: hasChanges ? 1 : 0,
            pointerEvents: hasChanges ? 'auto' : 'none'
          }}
        >
          Save
        </button>
        <button 
          type="button" 
          className="memory-add-button" 
          onClick={handleAddMemory}
        >
          <PlusSignIcon />
        </button>
      </div>

      {isImportOpen && <MemoryImportModal onClose={() => setIsImportOpen(false)} />}
    </div>
  );
}; 